// extracted by mini-css-extract-plugin
export var pillWrapper = "_js-0";
export var showOverflow = "_js-1";